import React from 'react';
import PlanMarkdownContent from './PlanMarkdownContent';

/**
 * PlanPdfCurrentView
 *
 * This component represents the exact DOM subtree we export when the end-user selects:
 * "Download PDF" -> "Current View (PDF)" on PlanCompletionCelebration.
 */
const PlanPdfCurrentView = ({ content = '' }) => {
  return (
    <div data-plan-pdf-current-view-root="true" className="bg-white dark:bg-gray-800 shadow-xl rounded-lg mx-auto" style={{ maxWidth: '850px' }}>
      <div className="p-6 md:p-10 prose dark:prose-invert max-w-none">
        <PlanMarkdownContent content={content} />
      </div>
    </div>
  );
};

export default PlanPdfCurrentView;


